import React from 'react';
import styles from './styles.module.css';
import MeasureSparkline from './MeasureSparkline';
import { computeDelta, formatDate, formatStep, formatValue, getMeasureInfo, measureSeries } from './bodyMeasurementsMath';

/**
 * Prévia de uma medida ao passar o mouse: quantos registros, a linha de
 * evolução em miniatura e o último valor com a variação em relação ao
 * anterior. Convida ao clique, que abre o histórico completo.
 */
const BodyMeasurePreview = ({ history, measureKey }) => {
  const info = getMeasureInfo(measureKey);
  if (!info) return null;

  const points = measureSeries(history, measureKey);
  const last = points[points.length - 1] || null;
  const previous = points[points.length - 2] || null;
  const step = last && previous ? formatStep(computeDelta(last.value, previous.value), info) : null;

  return (
    <div className={styles.preview}>
      <div className={styles.previewHead}>
        <span className={styles.previewTitle}>{info.label}</span>
        <span className={styles.previewCount}>
          {points.length === 1 ? '1 registro' : `${points.length} registros`}
        </span>
      </div>

      {points.length >= 2 ? (
        <MeasureSparkline values={points.map((point) => point.value)} />
      ) : (
        <span className={styles.previewHint}>A linha de evolução aparece a partir da segunda avaliação.</span>
      )}

      {last && (
        <div className={styles.previewLast}>
          <span>{formatDate(last.assessment.measuredAt)}</span>
          <span className={styles.previewValue}>{formatValue(last.value, info)}</span>
          {step && <span className={styles.deltaPill}>{step}</span>}
        </div>
      )}

      <span className={styles.previewHint}>Clique para ver o histórico completo</span>
    </div>
  );
};

export default BodyMeasurePreview;
